import { render, staticRenderFns } from "./ClaimUploadModal.vue?vue&type=template&id=53c27b34&scoped=true&"
import script from "./ClaimUploadModal.vue?vue&type=script&lang=js&"
export * from "./ClaimUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimUploadModal.vue?vue&type=style&index=0&id=53c27b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c27b34",
  null
  
)

export default component.exports